import React, { useEffect, useState } from "react";
import RadioButton from "./RadioButton";
import Title from "../text/Title";

interface RadioButtonGroupProps extends React.HTMLAttributes<HTMLInputElement>{  
  label?: string  
  values?: Array<{name: string, value: number | string}>
}

function RadioButtonGroup(props: Readonly<RadioButtonGroupProps>){
  const [checkedIndex, setCheckedIndex] = useState(-1);

  useEffect(() => {
    if (props.defaultValue && typeof(props.defaultValue) === "number"){
      setCheckedIndex(props.defaultValue)
    }
  }, [props.defaultValue]);  
  
  return(
    <div style={props.style}>
      <Title
        text={props.label}
      />
      <div>
        { props.values && 
          props.values.length > 0 &&
          props.values.map((val) =>
          <div key={'d' + val.value}>
            <label key={'l' + val.value}>{val.name}</label>
            <RadioButton
              key={'r' + val.value}
              value={val.value}
              checked={val.value === checkedIndex}
              onChange={(evt) => {
                setCheckedIndex(typeof(val.value) === "number" ? val.value : parseInt(val.value));
                props.onChange && props.onChange(evt)
              }}
            />
          </div>
          )
        }
      </div>
    </div>
  );
}


export default RadioButtonGroup;